import React, { Component } from 'react';
import { connect } from 'react-redux';
import SVGComponent from '../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../constants';
import { getPlayersTemplatePreview } from '../../selectors/teams';
import PlayersTemplatePreviewRows from './PlayersTemplatePreviewRows';
import { aSavePlayersTemplateRequest } from '../../reducers';

const mapToProps = (state) => ({
  playersTemplatePreview: getPlayersTemplatePreview(state),
});
const actionsToProps = (dispatch) => ({
  savePlayersTemplateRequest: (payload) => dispatch(aSavePlayersTemplateRequest(payload)),
});
class PlayersTemplatePreview extends Component {
  savePlayersTemplate = () => {
    this.props.savePlayersTemplateRequest({
      playerTemplateFileId: this.props.templateFileSelectedId,
      competitionId: this.props.competitionSelectedId,
    });
  };

  getTeamByIdOnLeagues = (teamId) => {
    const competition = this.props.leagues.find(
      (compet) => compet.id === this.props.competitionSelectedId,
    );
    return competition?.teams.find((t) => t.id === Number(teamId));
  };

  render() {
    const teamsId = Object.keys(this.props.playersTemplatePreview);
    return (
      <div className="modal modal--open">
        <div className="dialog dialog--selection">
          <div className="dialog__heading">
            <span className="dialog__title">New Teams Template</span>
            <SVGComponent
              src={`${SVG_ICONS.utility}#close`}
              className="dialog__close"
              onClick={this.props.closeModal}
            />
          </div>
          <div className="dialog__content">
            <div className="table-responsive fix-selection">
              <table className="event-selection">
                <thead>
                  <tr>
                    <th>Team Name</th>
                    <th className="th--sm">Operation</th>
                    <th>Player Name</th>
                    <th>Reference Name</th>
                    <th className="th--sm">Position</th>
                    <th className="th--sm">Probability</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.playersTemplatePreview
                    && teamsId?.map((teamId) => (
                      <React.Fragment key={teamId}>
                        <PlayersTemplatePreviewRows
                          team={this.getTeamByIdOnLeagues(teamId)}
                          playersGroupByStatus={this.props.playersTemplatePreview[teamId]}
                        />
                        <tr className="event-selection__row--seperator"><td colSpan="6" /></tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
            {teamsId.length === 0 && (
              <div className="dialog__informativeMsg">
                <div className="dialog__informativeMsgTxt">No changes applied with the application of this template !</div>
              </div>
            )}
          </div>
          <div className="dialog__btn-wrap">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Cancel</button>
            <button type="button" className="btn btn-primary m-l-10" onClick={this.savePlayersTemplate}>Confirm</button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapToProps, actionsToProps)(PlayersTemplatePreview);
